export default "__VITE_ASSET__Ctlii1gw__"